import { render, staticRenderFns } from "./swiperY.vue?vue&type=template&id=15154190&scoped=true&"
import script from "./swiperY.vue?vue&type=script&lang=js&"
export * from "./swiperY.vue?vue&type=script&lang=js&"
import style0 from "./swiperY.vue?vue&type=style&index=0&id=15154190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15154190",
  null
  
)

export default component.exports